export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#00ADA7',
    light: '#ebe8e7',
    contrastText: '#FFFFFF'
  },
  secondary: {
    main: '#43C2BD',
    contrastText: '#0A5285',
    light: '#D9EDF7'
  },
  text: {
    primary: '#1F2A34',
    secondary: '#23262F',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    arrow:'#292D32'
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#253F5F',
    paper: '#FFF',
    default: '#FFF',
    header: '#183635',
    footer: '#F9F9F5',
    level2: '#f7f8fb',
    level1: '#FFF',
    steps: '#43C2BD',
    tableHead: '#073745',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#004542',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#18CACF',
    secondary: 'rgb(240,243,243)',
    light: '#E5F0EF',
    arrow: '#00ADA7',
    secondaryLight: '#F9F9F5'
  },
  verticalBar: {
    used: '#3A1A10',
    unused: '#ebe8e7',
    unlimited: '#C0C0C0',
  }
};